<script setup lang="ts">
import { ref, onMounted } from 'vue'
import api from '@/api/client'
import TenantNotFound from '@/views/TenantNotFound.vue'

const checking = ref(true)
const tenantMissing = ref(false)

function isCentralHost(host: string): boolean {
  // The super-admin SPA lives on the reserved `admin` subdomain of ANY env
  // (admin.na12.ru, admin.staging.na12.ru, …). `admin` is a reserved SaaS
  // subdomain (never a tenant slug), so keying on the first label is safe and
  // avoids the tenant lookup that 404s on non-prod admin hosts.
  const label = host.split(':')[0].split('.')[0]
  return label === 'admin'
    || host === 'localhost'
    || host === '127.0.0.1'
    || !host.endsWith('.na12.ru')
}

onMounted(async () => {
  if (isCentralHost(window.location.hostname)) {
    checking.value = false
    return
  }
  try {
    await api.get('/tenant/info')
  } catch (err: any) {
    if (err.response?.status === 404) {
      tenantMissing.value = true
    }
  } finally {
    checking.value = false
  }
})
</script>

<template>
  <div v-if="checking" class="min-h-screen flex items-center justify-center bg-gray-50">
    <div class="animate-spin h-12 w-12 border-b-2 border-primary-600 rounded-full"></div>
  </div>
  <TenantNotFound v-else-if="tenantMissing" />
  <router-view v-else />
</template>
